import { BsCheck } from "react-icons/bs";

const SortingButton = ({ label, isActive, onClick }) => {
  return (
    <button
      className={`flex justify-center items-center w-24 h-9 rounded-[40px] border text-center text-sm font-bold ${
        isActive
          ? "bg-white border-neutral-400 text-neutral-600"
          : "bg-neutral-100 border-neutral-300 text-neutral-400"
      }`}
      onClick={onClick}
    >
      <span>
        <BsCheck className="text-2xl" />
      </span>
      {label}
    </button>
  );
};

export default SortingButton;
